<!-- Center canvas: summary, text typed into directly, matches Only Intro's badge+card pattern -->
<div
  class="cr-dc-card"
  *ngIf="isPreview"
  [id]="block.blockId"
>
  <span class="cr-dc-badge">Disclaimer</span>

  <span
    class="cr-dc-value"
    [appInlineEdit]="block.variables?.Disclaimer ?? ''"
    [inlineEditBlockId]="block.blockId"
    inlineEditPlaceholder="Insert disclaimer text"
    [inlineEditMultiline]="true"
    (inlineEditChange)="onChange($event, 'Disclaimer')"
  ></span>
</div>

<!-- Right panel: real edit form -->
<div class="cr-dc-edit" *ngIf="!isPreview">
  <app-field-editor-v2
    type="content"
    [multiline]="true"
    [showCounter]="true"
    [blockData]="block.variables?.Disclaimer ?? ''"
    (handleOnChange)="onChange($event, 'Disclaimer')"
    [placeholder]="disclaimerPlaceholder"
    [maxLength]="4000"
    variable="Disclaimer"
    [disabled]="disabled"
  ></app-field-editor-v2>
</div>
